import { ProductTypes } from '../../../../../../types';
import type { UnderwriteQuoteState } from '../../views/underwriter/types';

const uwUiSettingsBuilder = <T extends UnderwriteQuoteState>(data: T) => {
  return {
    ...data,
    uiSettings: {
      showClassDescription:
        data.productType === ProductTypes.prime_tech ||
        data.productType === ProductTypes.prime_one_tech,
    },
  };
};

export default uwUiSettingsBuilder;
